import axios from '../../http';

const state = {
  token: null
};

const getters = {
  token: state => state.token
};

const actions = {
  async getToken ({ state, commit, dispatch }) {
    try {
      const res = await axios({
        method: 'POST',
        baseURL: '/',
        url: 'auth/token'
      });
      commit('updateState', { prop: 'token', value: res.data });
      return res.data;
    } catch (error) {
      dispatch('page_loader/stop', null, { root: true });
      return null;
    }
  }
};

const mutations = {
  updateState (state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
